<template>
  <div :class="[question.Source?.toLowerCase()]">
    <div class="col-12 col-md-6 pa-0" :class="[question.StyleClass]">
      <HomeBaseLabel
        :question="question"
        :class="[question?.LabelStyleClass]"
      />
      <v-select
        :class="[question?.SelectBoxStyleClass]"
        dense
        outlined
        :hide-details="
          question.HideDetails != null ? question.HideDetails : 'auto'
        "
        placeholder="Please select..."
        :data-uiid="question.DataUiid"
        return-object
        :items="question.Options"
        item-text="Text"
        item-value="Value"
        v-model="question.Value"
        :rules="getRules"
        ref="selectBase"
        :aria-label="question.Text ?? ''"
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title :value="item.Value" :data-uiid="item.DataUiid">
              {{ item.Text }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-slot:append>
          <span>
            <v-icon
              v-if="!$refs.selectBase?.valid && $refs.selectBase?.hasMessages"
              color="red"
              size="20"
              :class="[question?.IconStyleClass]"
              >mdi-alert-circle</v-icon
            >
            <v-icon>mdi-menu-down</v-icon>
          </span>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";

export default {
  name: "SelectBase",
  components: {
    HomeBaseLabel,
  },
  mixins: [QuestionValidation],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  watch: {
    question: {
      handler(val) {
        this.$emit("change", val);
        this.question.Source = "User";
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.v-list-item.primary--text.v-list-item--active.v-list-item--link.theme--light.v-list-item--highlighted {
  color: white !important;
}
:deep(.v-text-field.v-text-field--enclosed .v-text-field__details) {
  padding-left: 0;
}
:deep(.select-base .v-input__control .v-input__slot .v-select__slot) {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.label {
  margin-top: 34px !important;
  margin-bottom: 9px;
}
.icon-mt {
  margin-top: 1px !important;
}
:deep(.v-text-field input::placeholder) {
  color: black !important;
}
</style>
